module.exports = __webpack_public_path__ + "static/telegrotesknext-bold-webfont-0dec0f16e1882f993610259840754fa6.woff";